import React from "react";
import { Navbar, Nav, Container, Image, Button } from "react-bootstrap";
import {
  Phone,
  Envelope,
  ArrowRight,
  Facebook,
  Instagram,
  Linkedin,
  Youtube,
} from "react-bootstrap-icons";
import { useAuth } from "../../contexts/AuthContext";
import logo from "../../assets/ieo.png";

const Header = () => {
  const { isAuthenticated, isAdmin, logout } = useAuth();

  // Updated color variables based on your theme
  const colors = {
    background: "#032530", // Dark teal
    cardBg: "#0b2c36", // Medium teal
    text: "#FFFFFF", // White text
    accent: "#ff8214", // Orange accent
    accentHover: "#ff9b44", // Lighter orange for hover
    border: "#1e273d", // Dark blue border
    adminBlue: "#018744", // Green for admin elements
    logoutRed: "#ff4757", // Red for logout
  };

  return (
    <>
      {/* Top Bar with Contact Info and Social Media */}
      <div
        style={{
          backgroundColor: "#13181f",
          padding: "8px 0",
          borderBottom: `1px solid ${colors.border}`,
        }}
      >
        <Container>
          <div className="d-flex justify-content-between align-items-center">
            {/* Contact Info */}
            <div className="d-flex align-items-center gap-4">
              <div className="d-flex align-items-center">
                <Phone
                  size={14}
                  className="me-2"
                  style={{ color: colors.accent }}
                />
                <small style={{ color: colors.text }}>+353899417647</small>
              </div>
              <div className="d-flex align-items-center">
                <Envelope
                  size={14}
                  className="me-2"
                  style={{ color: colors.accent }}
                />
                <small style={{ color: colors.text }}>
                  info@educationireland.net
                </small>
              </div>
            </div>

            {/* Social Media Icons */}
            <div className="d-flex align-items-center gap-3">
              <a
                href="https://www.facebook.com/IrelandEducationOffice"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.color = colors.accent;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.color = colors.text;
                }}
              >
                <Facebook size={16} style={{ color: colors.text }} />
              </a>

              <a
                href="https://www.instagram.com/accounts/login/?next=%2Fstudyireland_intl%2F&source=omni_redirect"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.color = colors.accent;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.color = colors.text;
                }}
              >
                <Instagram size={16} style={{ color: colors.text }} />
              </a>
              <a
                href="https://www.linkedin.com/company/ireland-education-office/?originalSubdomain=pk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.color = colors.accent;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.color = colors.text;
                }}
              >
                <Linkedin size={16} style={{ color: colors.text }} />
              </a>
              <a
                href="https://www.youtube.com/@Irelandeducationoffice"
                target="_blank"
                rel="noopener noreferrer"
                className="text-decoration-none"
                style={{
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.color = colors.accent;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.color = colors.text;
                }}
              >
                <Youtube size={16} style={{ color: colors.text }} />
              </a>
            </div>
          </div>
        </Container>
      </div>

      {/* Main Navbar */}
      <Navbar
        expand="lg"
        sticky="top"
        style={{
          backgroundColor: colors.cardBg,
          padding: "15px 0",
          transition: "all 0.3s ease",
          borderBottom: `1px solid ${colors.border}`,
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
        }}
      >
        <Container>
          {/* Company Logo */}
          <Navbar.Brand className="me-4">
            <Image
              src={logo}
              alt="Education Ireland Logo"
              height="45"
              className="d-inline-block align-top"
              style={{
                objectFit: "contain",
                maxWidth: "200px",
              }}
            />
          </Navbar.Brand>

          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{
              borderColor: colors.accent,
              backgroundColor: colors.background,
            }}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center gap-4">
              {/* Navigation Links */}
              <Nav.Link
                href="https://educationireland.net/"
                target="_blank"
                className="fw-medium"
                style={{
                  color: colors.text,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.accent)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
              >
                Visit Website
              </Nav.Link>

              <Nav.Link
                href="https://educationireland.net/contact/"
                target="_blank"
                className="fw-medium"
                style={{
                  color: colors.text,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.accent)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
              >
                Contact Us
              </Nav.Link>

              <Nav.Link
                href="https://educationireland.net/ask/"
                target="_blank"
                className="fw-medium"
                style={{
                  color: colors.text,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.accent)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
              >
                AI Advisor
              </Nav.Link>

              <Nav.Link
                href="https://courses.educationireland.net/"
                target="_blank"
                className="fw-medium"
                style={{
                  color: colors.text,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = colors.accent)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = colors.text)
                }
              >
                Course Search Engine
              </Nav.Link>

              {/* Apply Now Button */}
              <Button
                href="https://apply.educationireland.net/lead-form"
                target="_blank"
                className="d-flex align-items-center gap-2 px-4 py-2"
                style={{
                  backgroundColor: colors.accent,
                  borderColor: colors.accent,
                  borderRadius: "8px",
                  fontWeight: "600",
                  color: colors.background,
                  transition: "all 0.3s ease",
                  boxShadow: `0 0 15px ${colors.accent}40`,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = colors.accentHover;
                  e.currentTarget.style.borderColor = colors.accentHover;
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = `0 0 20px ${colors.accent}80`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = colors.accent;
                  e.currentTarget.style.borderColor = colors.accent;
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 0 15px ${colors.accent}40`;
                }}
              >
                Apply Now
                <ArrowRight size={16} />
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* CSS for sticky header behavior */}
      <style jsx="true">{`
        .sticky-nav {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 1030;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            transform: translateY(-100%);
          }
          to {
            transform: translateY(0);
          }
        }

        .nav-scrolled {
          padding: 10px 0 !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
        }

        .nav-link {
          position: relative;
          padding: 8px 12px !important;
        }

        .nav-link::after {
          content: "";
          position: absolute;
          width: 0;
          height: 2px;
          background: ${colors.accent};
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: width 0.3s ease;
          box-shadow: 0 0 5px ${colors.accent};
        }

        .nav-link:hover::after {
          width: 80%;
        }

        /* Social Media Icon Hover Effects */
        .social-icon-wrapper a:hover svg {
          transform: translateY(-2px);
          color: ${colors.accent} !important;
        }

        /* Navbar toggle button styles */
        .navbar-toggler {
          border-color: ${colors.accent} !important;
        }

        .navbar-toggler-icon {
          background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='${encodeURIComponent(
            colors.accent
          )}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
        }
      `}</style>
    </>
  );
};

export default Header;
